/** @format */

import axios from 'axios';
import { AOR, NPN, User, SaleSubmissionFormData, SubmissionResponse } from '../types';

const API_URL = process.env.REACT_APP_SIADASH_BACKEND_URL;

/**
 * Get authorization headers with access token
 */
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
  },
});

/**
 * Fetch list of AORs (Agent of Record)
 */
export const fetchAors = async (): Promise<AOR[]> => {
  try {
    const response = await axios.get(`${API_URL}/api/aor/aor-list`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Failed to fetch AORs:', error);
    throw new Error('Failed to fetch AORs');
  }
};

/**
 * Fetch list of NPNs (National Producer Number)
 */
export const fetchNpns = async (): Promise<NPN[]> => {
  try {
    const response = await axios.get(`${API_URL}/api/npn/npn-list`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Failed to fetch NPNs:', error);
    throw new Error('Failed to fetch NPNs');
  }
};

/**
 * Fetch list of agent users
 */
export const fetchUsers = async (): Promise<User[]> => {
  try {
    const response = await axios.get(`${API_URL}/api/users/agents`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw new Error('Failed to fetch users');
  }
};

/**
 * Submit sale submission form
 */
export const submitSaleForm = async (
  formData: SaleSubmissionFormData
): Promise<SubmissionResponse> => {
  try {
    // Debug logging
    console.log('Service submitting form with userId:', formData.userId);
    
    const response = await axios.post(
      `${API_URL}/api/insurance-policies/submit-form`,
      formData,
      getAuthHeaders()
    );

    return {
      success: true,
      message: 'Form submitted successfully',
      id: response.data?.id,
    };
  } catch (error) {
    console.error('Error submitting form:', error);
    throw new Error('Failed to submit form');
  }
};
